import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const VirtualsIcon = observer('VirtualsIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            fill='none'
            viewBox='0 0 24 24'
            className={className}
            onClick={onClick}
        >
            <path
                fill='#39B54A'
                d='M20.653 7.01c.175.308.068.699-.24.874l-1.115.635a.641.641 0 0 1-.634-1.115l1.115-.634a.641.641 0 0 1 .874.24ZM17.582 8.759a.641.641 0 0 1-.238.874l-.734.42a.641.641 0 0 1-.637-1.113l.734-.42a.641.641 0 0 1 .875.239ZM15.38 10.018a.641.641 0 0 1-.238.875l-.734.42a.641.641 0 0 1-.652-.009.64.64 0 0 1-.321.566l-.794.456v.911a.641.641 0 0 1-1.282 0v-.91l-.794-.457a.641.641 0 0 1 .639-1.112l.796.458.796-.458a.64.64 0 0 1 .653.008.64.64 0 0 1 .322-.566l.734-.42a.641.641 0 0 1 .875.238ZM12.641 15.494a.641.641 0 0 0-1.282 0v.847a.641.641 0 0 0 1.282 0v-.847ZM12.641 18.037a.641.641 0 1 0-1.282 0v.848c0 .246.139.46.342.567a.64.64 0 0 0-.342.567v1.282a.641.641 0 0 0 1.282 0V20.02a.64.64 0 0 0-.342-.567.64.64 0 0 0 .342-.567v-.848ZM5.699 7.99a.64.64 0 0 1 .652-.008l.727.417a.641.641 0 1 1-.637 1.112l-.728-.416a.64.64 0 0 1-.322-.56.64.64 0 0 1-.652.009L3.63 7.909a.641.641 0 1 1 .637-1.113l1.11.635a.64.64 0 0 1 .322.56ZM7.658 9.47a.641.641 0 0 1 .875-.238l.728.417a.641.641 0 1 1-.637 1.112l-.728-.416a.641.641 0 0 1-.238-.875Z'
            />
            <path
                fill='#FFFFFF'
                fillRule='evenodd'
                d='M12.824 2.22a1.66 1.66 0 0 0-1.648 0L3.95 6.391l-.001.001c-.517.296-.828.85-.828 1.434v8.346c0 .592.312 1.139.828 1.434h.001l7.222 4.172.003.002a1.66 1.66 0 0 0 1.648 0l.003-.002 7.222-4.171.002-.001c.517-.296.827-.85.827-1.434V7.827c0-.592-.313-1.139-.828-1.434h-.001L12.827 2.22l-.003-.002ZM11.36 3.593 4.587 7.505a.374.374 0 0 0-.183.322v7.818l3.288-1.899a.641.641 0 0 1 .641 1.11l-3.292 1.9 6.77 3.912h.002a.379.379 0 0 0 .374 0h.001l6.77-3.911-3.291-1.9a.641.641 0 1 1 .64-1.11l3.29 1.898V7.827a.366.366 0 0 0-.184-.322l-.003-.001-6.769-3.91V7.34a.641.641 0 1 1-1.282 0V3.594Z'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
